<template>
  <div id="bucket-file">
    <div class="button-group">
      <div class="filepath">
        <div v-if="pathRouter.length > 1">
          <span
            @click="
              pathClick(
                pathRouter[pathRouter.length - 2],
                pathRouter.length - 2
              )
            "
            ><i class="el-icon-ga-fanhui"></i> 返回上级</span
          >({{ pathRouter[pathRouter.length - 1].path }})
        </div>
      </div>
      <el-button size="small" @click="newDialog = true" type="primary"
        >新建文件夹</el-button
      >

      <el-button size="small" @click="uploadDialog = true">上传文件</el-button>
      <!-- <el-button
        size="small"
        @click="fileDelete"
        type="danger"
        plain
        :disabled="multipleSelection.length === 0"
        >删除文件</el-button
      > -->
      <el-dropdown @command="piClick">
        <el-button size="small" style="margin: 0 8px;">
          批量操作
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="del">
            <i class="el-icon-delete"></i> 删除
          </el-dropdown-item>
          <el-dropdown-item command="dwn">
            <i class="el-icon-download"></i> 下载
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button size="small" @click="refush">刷新</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      height="calc(100% - 32px * 2 - var(--padding) * 2)"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="45"></el-table-column>
      <el-table-column prop="filename" label="文件名" min-width="300">
        <template slot-scope="scope">
          <span
            v-if="ifFiledr(scope.row.key)"
            @click="folderClick(scope.row.key, scope.row.name)"
            class="path"
          >
            <i class="el-icon-ga-wjgl"></i>
            {{ scope.row.name }}
          </span>
          <span v-else>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="length"
        label="文件大小"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="mediaType"
        label="文件格式"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="contentEncoding"
        label="文件压缩方式"
        min-width="140"
      ></el-table-column>
      <el-table-column
        prop="lastModifyTime"
        label="修改时间"
        min-width="180"
      ></el-table-column>
      <el-table-column label="操作" width="70" align="center">
        <template slot-scope="scope">
          <el-dropdown
            placement="bottom"
            @command="handleCommand($event, scope.row)"
            szie="small"
          >
            <i class="el-icon-more icon-button"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="c" :disabled="ifFiledr(scope.row.key)">
                <i class="el-icon-ga-fuzhi"></i>
                <span class="caozuo-i">复制链接</span>
              </el-dropdown-item>
              <el-dropdown-item
                command="copyPath"
                :disabled="ifFiledr(scope.row.key)"
              >
                <i class="el-icon-ga-fuzhi"></i>
                <span class="caozuo-i">复制路径</span>
              </el-dropdown-item>
              <el-dropdown-item command="d" :disabled="ifFiledr(scope.row.key)">
                <i class="el-icon-ga-xiazai1"></i>
                <span class="caozuo-i">下载</span>
              </el-dropdown-item>
              <el-dropdown-item command="del">
                <i class="el-icon-delete"></i> 删除
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <page-trun
      :disabled="loading"
      :page="page"
      :queryData="queryData"
      :path="`${this.rootPath}_`"
      @pageTrun="pageTrun"
    />
    <bucket-file-dialog
      :dialog.sync="newDialog"
      :dialog2.sync="uploadDialog"
      :bucket-name="bucket.name"
      :parent="rootPath"
      @refush="refush"
    />
  </div>
</template>

<script>
import Clipboard from "clipboard";
import bucketFileDialog from "./bucketfiledialog.vue";
import { DeleteArr, Download, Delete } from "@/utils/index";
export default {
  name: "bucket-file",
  props: {
    bucket: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      newDialog: false,
      uploadDialog: false,
      queryData: {},
      rootPath: "/",
      pathRouter: [
        {
          name: "根目录",
          path: "/"
        }
      ],
      publicUrl: "",
      multipleSelection: [],
      page: {
        pageIndex: 0,
        hasMore: false,
        limit: 20,
        start: ""
      }
    };
  },

  computed: {
    tableData() {
      return this.queryData[`${this.rootPath}_${this.page.pageIndex}`];
    }
  },
  watch: {
    bucket: {
      immediate: true,
      handler(v) {
        if (v) {
          Object.assign(this.$data, this.$options.data());
          this.getData();
          this.setCopy();
        }
      }
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.$http
        .get(
          `/gavial/v1/mos/object/list?bucket=${this.bucket.name}&dir=${this.rootPath}&start=${this.page.start}`
        )
        .then(res => {
          this.page.pageIndex++;
          this.page.start = res.data.data.nextMarker || "";
          if (res.data.data.nextMarker !== null) {
            this.page.hasMore = true;
          } else {
            this.page.hasMore = false;
          }
          this.$set(
            this.queryData,
            `${this.rootPath}_${this.page.pageIndex}`,
            res.data.data.objectList
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setCopy() {
      this.$http.get("/gavial/v1/mos/object/endpoints").then(res => {
        this.publicUrl = res.data.data.public + "/object/content/";
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCommand(type, row) {
      switch (type) {
        case "c":
          this.fileCopy(row);
          break;
        case "d":
          this.fileDownload(row.key, row.name);
          break;
        case "del":
          this.flieDelete(row.key, row.name);
          break;
        case "copyPath":
          this.fileCopy(row, true);
          break;
      }
    },
    fileCopy(row, path = false) {
      let clip = new Clipboard(".copy-button");

      clip.on("success", () => {
        this.$message({
          type: "success",
          message: (path ? "路径" : "链接") + "已复制"
        });
      });
      let button = document.createElement("button");
      button.className = "copy-button";
      button.setAttribute(
        "data-clipboard-text",
        path ? row.key : this.publicUrl + this.bucket.name + row.key
      );
      document.body.appendChild(button);
      button.click();
      document.body.removeChild(button);
      clip.destroy();
    },
    ifFiledr(data) {
      let reg = /.\/$/gi;
      return reg.test(data);
    },
    folderClick(row, name) {
      this.pathRouter.push({
        name,
        path: row
      });
      this.rootPath = row;
      this.page = {
        pageIndex: 1,
        hasMore: false,
        limit: 20,
        start: ""
      };
      if (!this.tableData) {
        this.page.pageIndex = 0;
        this.getData();
      }
    },
    pathClick(path, i) {
      if (i !== this.pathRouter.length - 1) {
        let index = this.pathRouter.indexOf(path);
        this.pathRouter.splice(index);
        this.folderClick(path.path, path.name);
      }
    },
    flieDelete(path, filename) {
      Delete(
        `/gavial/v1/mos/object?bucket=${
          this.bucket.name
        }&key=${encodeURIComponent(path)}`,
        filename,
        () => {
          this.queryData = {};
          this.page = {
            pageIndex: 0,
            hasMore: false,
            limit: 20,
            start: ""
          };
          this.getData();
        },
        bool => {
          this.loading = bool;
        }
      );
    },
    fileDownload(path, filename) {
      Download(
        `/gavial/v1/mos/object/content/${this.bucket.name}${encodeURIComponent(
          path
        )}`,
        filename
      );
    },

    refush() {
      this.page = {
        pageIndex: 0,
        hasMore: false,
        limit: 20,
        start: ""
      };
      this.queryData = {};
      this.getData();
    },
    pageTrun(i) {
      if (!this.queryData[`${this.rootPath}_${i}`]) {
        this.getData();
      } else {
        this.page.pageIndex = i;
      }
    },
    // 批量操作
    piClick(key) {
      if (this.multipleSelection.length === 0) {
        return this.$message({
          type: "error",
          message: "请先选择需要操作的文件(夹)"
        });
      } else if (this.multipleSelection.length > 10) {
        return this.$message({
          type: "error",
          message: "批量操作文件(夹)个数不能超过10个"
        });
      }
      switch (key) {
        case "del":
          this.filesDelete();
          break;

        case "dwn":
          this.filesDownload();
          break;
      }
    },
    filesDelete() {
      let queryArr = this.multipleSelection.map(
        data =>
          `/gavial/v1/mos/object?bucket=${
            this.bucket.name
          }&key=${encodeURIComponent(data.key)}`
      );

      let nameArr = this.multipleSelection.map(data => {
        return data.name;
      });

      DeleteArr(
        queryArr,
        nameArr,
        () => {
          this.queryData = {};

          this.page = {
            pageIndex: 0,
            hasMore: false,
            limit: 20,
            start: ""
          };
          this.getData();
        },
        bool => {
          this.loading = bool;
        }
      );
    },
    filesDownload() {
      this.multipleSelection.forEach((item, index) => {
        if (this.ifFiledr(item.key)) return;
        Download(
          `/gavial/v1/mos/object/content/${
            this.bucket.name
          }${encodeURIComponent(item.key)}`,
          item.name,
          index
        );
      });
    }
  },
  components: {
    bucketFileDialog
  }
};
</script>

<style lang="scss">
#bucket-file {
  height: 100%;
  display: flex;
  flex-direction: column;
  .button-group {
    margin-top: var(--padding);
  }
  .el-table {
    flex: 0 0 auto;
  }
  .filepath {
    padding: 0 10px;
    height: 32px;
    line-height: 32px;
    // user-select: none;
    flex: 1 1 auto;
    overflow: hidden;
    & > div > span {
      cursor: pointer;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      &:hover {
        color: var(--blue);
      }
    }
  }
}
</style>
